// axios 配置
import axios from 'axios'
import qs from 'qs'
import router from '@router/index.js'
import { Message } from 'element-ui'
import customizeInd from '@customizeProMixins/getCustomizeInd'
// import app from '../main'

let isBuildDev, httpBase
if (
  process.env.NODE_ENV === 'development' &&
  process.env.VUE_APP_API === 'development'
) {
  isBuildDev = 'location'
  // httpBase = '/'
  console.debug('本地开发')
} else if (
  process.env.NODE_ENV === 'production' &&
  process.env.VUE_APP_API === 'development'
) {
  isBuildDev = 'buildDev'
  console.debug('测试打包')
} else {
  isBuildDev = 'production'
  console.debug('正式打包 customizeInd:', customizeInd)
}

// post content-type 是 application/json的接口, 默认是application/x-www-form-urlencoded
const applicationJsonApiUrlArr = ['/marathon/hl/template/params']

function resHandler(response) {
  let flag = false
  if (response.config.url.indexOf('dynamicConfig.json') > -1) {
    return true
  }
  if (response.data.status === 0) {
    // 成功
    flag = true
  } else if (response.data.status === -1) {
    console.debug('接口异常', response)
    if (response.config.url.indexOf('/marathon/vcr/clip/athlete/rate') > -1) {
      // 查进度条的接口，报错不显示
    } else {
      Message({
        showClose: true,
        message: response.data.message,
        type: 'warning',
      })
    }
  } else if (response.data.status === 9) {
    console.debug('用户登录状态已过期，请重新登录:', customizeInd)

    if (customizeInd === 0) {
      router.replace({ path: '/login/index' })
    } else if (customizeInd === 1) {
      console.debug('CCTV 登录过期')
      // sessionStorage.clear()
      // localStorage.clear()
      Message({
        showClose: true,
        message: response.data.message,
        type: 'warning',
      })
      let curLocationOrigin = window.location.origin
      setTimeout(() => {
        window.location = `${curLocationOrigin}/unification/unauth`
      }, 2 * 1000)
    }

    // router.replace({ path: '/login/index' })
  } else if (response.data.status >= 500 && response.data.status < 600) {
    // 服务器错误
    console.debug('服务器错误')
    Message({
      showClose: true,
      message: response.data.message,
      type: 'warning',
    })
  } else if (response.data.status === 9001) {
    // 用户所属站点冻结
    console.debug('用户所属站点冻结')
    Message({
      showClose: true,
      message: response.data.message,
      type: 'warning',
    })
  } else if (response.data.status === 9002) {
    // 账号被冻结
    console.debug('账号被冻结')
    Message({
      showClose: true,
      message: response.data.message,
      type: 'warning',
    })
  } else {
    Message({
      showClose: true,
      message: response.data.message,
      type: 'warning',
    })
  }
  return flag
}

//创建 axios 实例
function CreateAxios(httpBase) {
  axios.defaults.headers.common['Content-Type'] =
    'application/x-www-form-urlencoded'
  //`withCredentials` 表示跨域请求时是否需要使用凭证
  axios.defaults.withCredentials = true
  let instance = axios.create({
    // baseURL: httpBase,
    timeout: 60 * 1000, // 原来请求超过15秒即超时返回错误
    //  application/json;charset=UTF-8
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
      // "Access-Control-Allow-Origin": "*",
      // "Access-Control-Allow-Methods": "GET"
    },
    // responseType: 'blob'
  })

  // request 拦截器
  instance.interceptors.request.use(
    (config) => {
      // if (token) {
      //   // 若存在token，则每个Http Header都加上token
      //   console.debug("拿到token");
      //   config.headers.Authorization = `Bearer ${token}`;
      // }
      // console.debug(
      //   config.headers,
      //   config.headers['Content-Type'],
      //   config.headers.common['Accept'],
      //   config.headers.common['Accept'].indexOf('application/json'),
      //   config.headers.common['Accept'].indexOf('application/json') === 0,
      //   config.url.indexOf('/ftcup/image/uploadImage')
      // )
      if (config.method === 'post') {
        if (config.url.indexOf('/dataposter/rmbg/submit') > -1) {
          console.debug('application/json', config)
        } else if (config.url.indexOf('/cdvData/') === 0) {
          // config.data = qs.stringify(config.data)
          // config.baseURL = 'http://127.0.0.1:9029'
        } else if (
          applicationJsonApiUrlArr.some((item) => {
            console.debug(item, config.url.indexOf(item))
            return config.url.indexOf(item) >= 0
          })
        ) {
          console.debug('application/json', config, config.data)
          config.data = JSON.stringify(config.data)
        } else if (config.url.indexOf('/prog/work/importExcel') > -1) {
          // 节目单 批量上传文件 不需要做任何处理
        } else if (
          config.url.indexOf('/ftcup/image/uploadImage') < 0 &&
          config.url.indexOf('/tennis/image/uploadImage') < 0
        ) {
          config.data = qs.stringify(config.data)
        } else {
        }
      }
      console.debug('request请求配置', config)
      return config
    },
    (err) => {
      // console.debug(`请求：${err}`)
      return Promise.reject(err)
    }
  )

  // http response 拦截器
  instance.interceptors.response.use(
    (response) => {
      // console.debug("成功响应：", response);
      let flag = resHandler(response)
      // if (response.data.status === 9) {
      //   console.debug('用户登录状态已过期，请重新登录')
      //   // sessionStorage.clear()
      //   // localStorage.clear()
      //   router.replace({ path: '/login/index' })
      // }
      if (flag) {
        return response
      }
    },
    (error) => {
      let isNetWorkFlag = true
      if (error.response) {
        isNetWorkFlag = false
        switch (error.response.status) {
          case 404:
            // 返回 404
            break
          default:
            // console.debug("服务器出错，请稍后重试！");
            if (
              error.response.status === 504 ||
              error.response.status === 502
            ) {
              isNetWorkFlag = true
            }
            console.debug(window.axiosErrTimeOut, error.response.status)
        }
        // console.debug("存在error.response");
      }
      // console.debug(
      //   window.axiosErrTimeOut,
      //   error.message,
      //   error.config,
      //   error.request
      // );
      if (isNetWorkFlag) {
        window.axiosErrTimeOut = window.axiosErrTimeOut
          ? window.axiosErrTimeOut - 0 + 1
          : 1
        console.debug(window.axiosErrTimeOut)
        return Promise.reject({
          data: null,
          message: '网络异常',
          status: 502,
        })
      } else {
        Message({
          showClose: true,
          message: '服务器异常，请稍后再试',
          type: 'warning',
        })
        return Promise.reject(error.response) // 返回接口返回的错误信息
      }
    }
  )

  instance.mock = function (data) {
    let promise_xhr = new Promise((resolve, reject) => {
      resolve(data)
    })
    return promise_xhr
  }

  return instance
}

export default CreateAxios()
